import {AppValidators} from '@brunata-angular/util';
import {AccountPeriodControl} from '../reporting-form-controls';
import {AbstractControl, ValidationErrors} from '@angular/forms';

export class AccountPeriodValidator {
    public static endDateIsAfterStartDateValidator(
        control: AbstractControl,
    ): ValidationErrors | null {
        const accountPeriodControl = control as AccountPeriodControl;
        if (
            AppValidators.isEmptyInputValue(accountPeriodControl.value.endDate) ||
            AppValidators.isEmptyInputValue(accountPeriodControl.value.startDate) ||
            accountPeriodControl.value.endDate === undefined ||
            accountPeriodControl.value.startDate === undefined
        ) {
            return null; // Don't validate empty values to allow optional controls
        }
        return accountPeriodControl.value.startDate != null &&
            accountPeriodControl.value.endDate != null &&
            accountPeriodControl.value.endDate < accountPeriodControl.value.startDate
            ? {
                  endDateIsBeforeStartDate: {
                      min: accountPeriodControl.value.startDate,
                      actual: accountPeriodControl.value.endDate,
                  },
              }
            : null;
    }
}
